/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-89b33ff6.mjs';
import { isVNode, defineComponent, toRefs, computed, h, createVNode } from 'vue';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import props from './check-tag-group-props.mjs';
import _CheckTag from './check-tag.mjs';
import useVModel from '../hooks/useVModel.mjs';
import { i as isFunction_1 } from '../_chunks/dep-97c71289.mjs';
import '../_chunks/dep-6bcce672.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-493c38ce.mjs';
import '../_chunks/dep-6f3e4f56.mjs';
import '../_chunks/dep-b56b2dc0.mjs';
import '../_chunks/dep-77f634fb.mjs';
import '../_chunks/dep-28ae3cda.mjs';
import '../_chunks/dep-e50fa7b0.mjs';
import '../_chunks/dep-ae08d6c4.mjs';
import '../_chunks/dep-b1060562.mjs';
import '../_chunks/dep-b333ab93.mjs';
import '../_chunks/dep-4efc69ee.mjs';
import '../_chunks/dep-7211604f.mjs';
import '../_chunks/dep-75df64b1.mjs';
import '../_chunks/dep-48b9a098.mjs';
import '../_chunks/dep-c7e4942d.mjs';
import '../_chunks/dep-8049d2e0.mjs';
import '../_chunks/dep-0d1bd08c.mjs';
import '../_chunks/dep-c5d88cfe.mjs';
import '../_chunks/dep-25d66c95.mjs';
import '../_chunks/dep-372265bb.mjs';
import '../_chunks/dep-d940e2da.mjs';
import '../_chunks/dep-52c1d6a9.mjs';
import '../_chunks/dep-18bb982b.mjs';
import '../_chunks/dep-c57d8117.mjs';
import '../_chunks/dep-6043e9fc.mjs';
import '../_chunks/dep-5f6c8826.mjs';
import '../_chunks/dep-3a045465.mjs';
import '../_chunks/dep-53dc0ac1.mjs';
import '../_chunks/dep-b6b4eaa3.mjs';
import '../_chunks/dep-881cffb7.mjs';
import '../_chunks/dep-436b338d.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-2d31a683.mjs';
import '../_chunks/dep-3ddc95d0.mjs';
import '../config-provider/type.mjs';
import '../_chunks/dep-a26b9c60.mjs';
import './check-tag-props.mjs';
import '../hooks/tnode.mjs';
import '../_chunks/dep-0a6fd248.mjs';
import '../_chunks/dep-7ad89920.mjs';
import '../_chunks/dep-36563716.mjs';
import '../_chunks/dep-b1013215.mjs';
import '../_chunks/dep-91fc304f.mjs';
import '../_chunks/dep-17446155.mjs';
import '../_chunks/dep-8747fcf0.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ec227f3f.mjs';
import './tag.mjs';
import 'tdesign-icons-vue-next';
import './props.mjs';
import '../hooks/useGlobalIcon.mjs';
import '../_common/js/common.mjs';

function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !isVNode(s);
}
var _CheckTagGroup = defineComponent({
  name: "TCheckTagGroup",
  props: props,
  setup: function setup(props2, context) {
    var _toRefs = toRefs(props2),
      value = _toRefs.value,
      modelValue = _toRefs.modelValue,
      options = _toRefs.options;
    var componentName = usePrefixClass("check-tag-group");
    var checkTagGroupClasses = computed(function () {
      return [componentName.value];
    });
    var _useVModel = useVModel(value, modelValue, props2.defaultValue, props2.onChange),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      innerValue = _useVModel2[0],
      setInnerValue = _useVModel2[1];
    var onCheckTagChange = function onCheckTagChange(checked, ctx) {
      var value2 = ctx.value;
      if (checked) {
        if (props2.multiple) {
          setInnerValue(innerValue.value.concat(value2), {
            e: ctx.e,
            type: "check",
            value: value2
          });
        } else {
          setInnerValue([value2], {
            e: ctx.e,
            type: "check",
            value: value2
          });
        }
      } else {
        var newValue = [];
        if (props2.multiple) {
          newValue = innerValue.value.filter(function (t) {
            return t !== value2;
          });
        }
        setInnerValue(newValue, {
          e: ctx.e,
          type: "uncheck",
          value: value2
        });
      }
    };
    var getTagContent = function getTagContent(option) {
      if (context.slots.option) return context.slots.option(option);
      if (context.slots.label) return context.slots.label(option);
      if (option.label) {
        return isFunction_1(option.label) ? option.label(h) : option.label;
      }
      if (option.content && isFunction_1(option.content)) return option.content(h);
      if (option["default"] && isFunction_1(option["default"])) return option["default"](h);
      return option.value;
    };
    return function () {
      return createVNode("div", {
        "class": checkTagGroupClasses.value
      }, [(options.value || []).map(function (option) {
        var _slot;
        return createVNode(_CheckTag, {
          "key": option.value,
          "value": option.value,
          "checkedProps": props2.checkedProps,
          "uncheckedProps": props2.uncheckedProps,
          "checked": innerValue.value.includes(option.value),
          "onChange": onCheckTagChange,
          "disabled": option.disabled,
          "size": option.size,
          "data-value": option.value
        }, _isSlot(_slot = getTagContent(option)) ? _slot : {
          "default": function _default() {
            return [_slot];
          }
        });
      })]);
    };
  }
});

export { _CheckTagGroup as default };
//# sourceMappingURL=check-tag-group.mjs.map
